import React, {Component} from 'react';
import {  Select, Form, Tabs, Button,Tree,message,Checkbox,Radio,Modal,Input} from 'antd';

import './style.css'
import Question from '../../../../entry_question_editor/question/question_view/view';
import axios from 'axios'
import API from '../../../../API/api'



const $ = require('$');
const MathQuill = require('MathQuill');
const MQ = MathQuill.getInterface(2);


class QuestionList extends Component {
    state = {
        selectQuestions: [],
        reworkModal:false,
        mark:'',

    }
    evaluatingSave=(v,task_id,tree_id,is_evaluation,choice,stage)=>{
        let oldchoice = v.choice
        let newchoice = choice
        let data = {
            is_evaluation,
            choice,
            question_id:v.question_id,
            task_id,
            tree_id
        }
        let changeCount = ()=>{
            //用来改变列表上方的统计数据

            if(is_evaluation!==-1){//评测题情况
                let str = 'question_base_count_evaluation'
                if(v.type_show=='49'||v.type_show=='35'){//计算题的情况
                    str = 'question_calculation_count_evaluation'
                }
                this.props.changeCount(str,is_evaluation?1:-1)
            }
            let choseFn = (choice,add)=>{//题包类型情况
                let str = 'question_base_count_normal'
                if((choice)==='0'){
                    str = 'question_base_count_normal'
                    if(v.type_show=='49'||v.type_show=='35'){//计算题的情况
                        str = 'question_calculation_count_normal'
                    }
                }
                if((choice)==='1'){
                    str = 'question_base_count_afterclass'
                    if(v.type_show=='49'||v.type_show=='35'){//计算题的情况
                        str = 'question_calculation_count_afterclass'
                    }
                }
                if((choice)==='2'){
                    str = 'question_base_count_extend'
                    if(v.type_show=='49'||v.type_show=='35'){//计算题的情况
                        str = 'question_calculation_count_extend'
                    }
                }
                this.props.changeCount(str,add)
            }
            if(choice!==-1){
                choseFn(''+oldchoice,-1)//原题型 减
                choseFn(''+newchoice,1)//变为什么题型 加
            }
        }

        if(stage=='checking'){
            axios.post(API.EVALUATION_TASK_QUESTION_MOD_SUBMIT,data).then((res)=>{
                res = res.data
                if (res.code === 0) {
                    changeCount()

                    this.forceUpdate()
                }else{
                    message.error(res.message);
                }
            },(error)=>{
                message.error('网络错误！');
            });
        }
        axios.post(API.EVALUATION_TASK_QUESTION_SUBMIT,data).then((res)=>{
            res = res.data
            if (res.code === 0) {
                changeCount()
                this.forceUpdate()

            }else{
                message.error(res.message);
            }
        },(error)=>{
            message.error('网络错误！');
        });
    }


    componentDidUpdate() {
        $('.viewer .mathquill-embedded-latex', this.refs.viewer)
            .removeAttr('style')
            .each(function (index, item) {
                // 然而, 我们这里并不是可编辑的
                MQ.StaticMath(item);
            });
    }
    componentDidMount() {
        $('.viewer .mathquill-embedded-latex', this.refs.viewer)
            .removeAttr('style')
            .each(function (index, item) {
                // 然而, 我们这里并不是可编辑的
                MQ.StaticMath(item);
            });
    }

    createHtml = str => ({__html: str ? str : `&nbsp;`});

    render() {
        let  {data = {},taskId = '',pagesize=10,role_evaluation,stage,k,tree_id} = this.props;

        if(!role_evaluation||stage===''){
            return null
        }
        data.id = data.question_id;
        data.rate = data.right_rate;
        // data.isChapter = true;
        let v = data;
        let page = this.props.page;
        if(!page){page = 1}

        let disabled = false
        if(stage!=='signing'&& stage!=='checking'&& stage!=='rework'){
            disabled = true
        }
        return (
            <div>
                {
                    <div key={v.question_id} style={{marginBottom: '30px',position:'relative',overflow:'hidden'}}>
                        <div className={'question'} style={{float:'left',width:'calc(100% - 200px)'}}>
                            {/* stage!=='signing'?true:false */}
                            <Question data={v} isChapter={true}  num={(page-1)*pagesize+k} defaultHideFooterInfo={1} canShowFooterInfo={true} canShowAnswer={false} questionType={v.questionType}/>

                        </div>
                        {
                            <div className={'question_explain_content'} style={{minHeight:'200px',width:'190px',float: 'left',marginLeft:'10px'}} ref={'viewer'}>
                                <div style={{fontSize:'14px'}}>
                                    <div style={{marginBottom:25,padding:10}}>
                                        <div style={{marginBottom:10}}>
                                            <span>评测题：</span><Checkbox disabled={disabled} style={{marginLeft:5}} checked = { !!(~~v.is_evaluation) } onChange = { (e)=>{v.is_evaluation=~~e.target.checked;this.evaluatingSave(v,taskId,tree_id,~~e.target.checked,-1,stage)} }/>
                                        </div>
                                        <div>
                                            <div style={{marginBottom:5}}>
                                                题包类型：
                                            </div>
                                            <div style={{textAlign:'center'}}>
                                                <Radio.Group value={''+v.choice} disabled={disabled} onChange={(e)=>{this.evaluatingSave(v,taskId,tree_id,-1,~~e.target.value,stage);v.choice=e.target.value;}}>
                                                    <Radio value="0" style={{display:'block'}}>普通题</Radio>
                                                    <Radio value="1" style={{display:'block'}}>课后题</Radio>
                                                    <Radio value="2" style={{display:'block'}}>扩展题</Radio>
                                                </Radio.Group>
                                            </div>

                                        </div>
                                    </div>



                                </div>
                            </div>
                        }
                    </div>
                }
            </div>
        )
    }
}

export default QuestionList





// WEBPACK FOOTER //
// ./src/entry_app/question_manage/question_evaluating/evaluating_detail_question/view.js